import React, { createContext, useCallback, useContext, useState } from "react";
import api from "../api/axios";

type NotificationsContextValue = {
  hasNew: boolean;
  refreshHasNew: () => Promise<void>;
  clearHasNew: () => void;
};

const NotificationsContext = createContext<NotificationsContextValue>({
  hasNew: false,
  refreshHasNew: async () => {},
  clearHasNew: () => {},
});

export const useNotificationsStatus = () => useContext(NotificationsContext);

export function NotificationsProvider({ children }: { children: React.ReactNode }) {
  const [hasNew, setHasNew] = useState(false);

  const refreshHasNew = useCallback(async () => {
    try {
      const res = await api.get("/pos/notifications/has-new");
      setHasNew(!!res.data?.hasNew);
    } catch {
      // best-effort indicator
    }
  }, []);

  const clearHasNew = useCallback(() => setHasNew(false), []);

  return (
    <NotificationsContext.Provider value={{ hasNew, refreshHasNew, clearHasNew }}>
      {children}
    </NotificationsContext.Provider>
  );
}
